import { Routes } from '@angular/router';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { LOAN_ROUTES } from './components/loan/loan.routes';
import { LoanComponent } from './components/loan/loan.component';
import { LoginComponent } from './components/login/login.component';
import { AuthguardService } from './services/authguard/authguard.service';
import { RegisterComponent } from './components/register/register.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ChangePasswordComponent } from './components/account/change-password/change-password.component';
import { RecoverUsernameComponent } from './components/account/recover-username/recover-username.component';
import { StaticComponent } from './components/static/static.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthguardService],
    children: [
      {
        path: '',
        component: LoanComponent,
      },
      {
        path: 'loan/:id',
        component: LoanComponent,
        children: LOAN_ROUTES,
      },
       { path: 'account/change-password', component: ChangePasswordComponent },
    ]
  },
  {
    path: 'static/:object',
    component: StaticComponent,
    canActivate: [AuthguardService],
  },
  {
    path: 'login',
    component: LoginComponent,
  }, {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
    { path: 'recover-username', component: RecoverUsernameComponent },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  }
];
